<template>
  <div>
    <div class="flex gap-2 items-center mb-4">
      <select v-model="dateFilter" @change="handleDateFilter"
        class="p-2 w-32 text-black capitalize border border-gray-700 dark:text-white dark:border-gray-300">
        <option v-for="option in options" :key="option" :value="option" class="text-black dark:text-white">{{
          option.replace('_', ' ') }}</option>
      </select>
      <button v-if="dateFilter === 'custom'" @click="showCustomDate = true" class="text-sm text-green-600 dark:text-green-400">Change Range</button>
    </div>
    <Dialog v-model:visible="showCustomDate" modal
      :dismissableMask="true" header="Select Date Range"
      :style="{ width: '25rem' }">
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <label for="startDate">Start Date</label>
          <input type="date" id="startDate" v-model="startDate"
            class="inline-block p-2 w-40 text-gray-700 border border-gray-700 dark:border-gray-300 dark:text-white" />
        </div>
        <div class="flex flex-col gap-2">
          <label for="endDate">End Date</label>
          <input type="date" id="endDate" v-model="endDate" :min="startDate"
            class="inline-block p-2 w-40 text-gray-700 border border-gray-700 dark:border-gray-300 dark:text-white" />

        </div>
        <div class="flex gap-2 justify-end">
          <button @click="showCustomDate = false" class="px-4 py-2 text-white bg-gray-500 rounded-md">Cancel</button>
          <button @click="handleCustomDate" class="px-4 py-2 text-white bg-blue-500 rounded-md">Apply</button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import Dialog from 'primevue/dialog';
import DatePicker from 'primevue/datepicker';

const options = [
  'all_time',
  'today',
  'yesterday',
  'this_week',
  'last_week',
  'this_month',
  'last_month',
  'this_year',
  'last_year',
  'custom'
]
const emit = defineEmits(['dateFilter'])
const dateFilter = ref('today')
const showCustomDate = ref(false)
const startDate = ref(new Date().toISOString().split('T')[0])
const endDate = ref(new Date().toISOString().split('T')[0])

const handleDateFilter = (e) => {
  if (dateFilter.value === 'custom') {
    showCustomDate.value = true
  } else {
    emit('dateFilter', dateFilter.value)
  }
}

watch(showCustomDate, (newVal) => {
  if (!newVal && startDate.value === new Date().toISOString().split('T')[0] && endDate.value === new Date().toISOString().split('T')[0]) {
    dateFilter.value = 'today'
  }
})

const handleCustomDate = () => {
  emit('dateFilter', 'custom', startDate.value, endDate.value)
  showCustomDate.value = false
}


</script>

<style scoped>
.p-dialog-content {
  padding: 0 !important;
}
</style>
